/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-children-prop */
import React, { FC, useEffect, useState } from 'react';
import { Container, CssBaseline, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/User';
import Header from '../../../../components/Header';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import imgWinningRegister from '../../../../assets/images/tela_cadastro_premiado.png';

import ModalListCenter from '../../../../components/Modal/ListCenter';
import ModalConfirmFooter from '../../../../components/Modal/ConfirmFooter';
import { getStorege } from '../../../../helpers/db_storage';

type WinningRegisterProps = {
  arrFormaPagamentos: [];
  arrPremios: [];
  dsFiltroPagamento: string;
  dsPremiacao: string;
  dsUrlSorteio: string;
  dtCriacao: any;
  dtFim: any;
  dtInicio: any;
  dtPremiacao: any;
  flgAtivo: string;
  hrPremiacao: string;
  idMarketplace: string;
  idPremiacao: string;
  qtGanhadores: string;
  vlMinimo: string;
};

const Winningregister: FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();

  const [openModalNotice, setOpenModalNotice] = useState(false);
  const [noUseAwardedOrder, setNoUseAwardedOrder] = useState(false);
  const [msgnModalNotice, setMsgModalNotice] = useState({
    title: 'Atenção',
    messagem: '',
  });

  const [dataWinningRegister, setDataWinningRegister] =
    useState<WinningRegisterProps>({} as WinningRegisterProps);

  const [dataListAwarded, setDataListAwarded] = useState<any>([]);
  const [dataListWinners, setDataListWinners] = useState<any>([]);
  const [openModalListPaymentFormat, setOpenModalListPaymentFormat] =
    useState(false);
  const [openModalListAwards, setOpenModalListAwards] = useState(false);
  const [openModalListWinners, setOpenModalListWinners] = useState(false);

  const [dataStorageCity, setDataStorageCity] = useState<any>('');

  const handleToPage = (url: string, replace = false): void => {
    return navigate(url, { replace });
  };

  const handleCloseModalNotice = (): void => {
    setOpenModalNotice(false);
    setNoUseAwardedOrder(false);
    if (!dataWinningRegister?.idPremiacao) {
      handleToPage('/fidelity', true);
    }
  };

  const getAwardedOrder = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.auth.awardedOrder({
          nr_operacao: 69,
          idMarketplace: dataStorageCity?.idMarketplace,
        });

      if (!result.data[0]) {
        setMsgModalNotice({
          title: 'ATENÇÃO!',
          messagem: 'Não há premiação ativa no momento na sua cidade.',
        });
        setOpenModalNotice(true);
        setNoUseAwardedOrder(true);
        return;
      }

      // Array para armazenar premios
      const awarded = result.data[0].arrPremios.map(
        ({ dsPremio, nrPosicao, idPremiacao, idGanhador }: any) => ({
          idGanhador,
          dsPremio,
          nrPosicao,
          idPremiacao,
        }),
      );

      // Array para armazenar ganhadores
      const winners = result.data[0].arrPremios.map(
        ({ dsNome, nrPosicao, idPremiacao, idGanhador }: any) => ({
          idGanhador,
          dsNome,
          nrPosicao,
          idPremiacao,
        }),
      );

      setDataListAwarded(awarded);
      setDataListWinners(winners);

      setDataWinningRegister(result.data[0]);
    } catch (error) {
      toast.error('Ocorreu um erro, tente novamente mais tarde');
    }
  };

  const handleToLink = (url: string): void => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  };

  useEffect(() => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (!dataUserStorage?.idUsuario) {
      toast.info(
        'Você precisa está logado para acessar o programa de recompensa.',
      );

      handleToPage('/fidelity', true);
    }
  }, []);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    setDataStorageCity(dataStorage);
  }, []);

  useEffect(() => {
    if (dataStorageCity) {
      getAwardedOrder();
    }
  }, [dataStorageCity]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (noUseAwardedOrder) {
        handleToPage('/fidelity', true);
      }
    }, 4000);

    return () => clearTimeout(timerId); // Limpar o setTimeout quando o componente é desmontado
  }, [noUseAwardedOrder]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Cashback" />
      {dataWinningRegister.idPremiacao && (
        <>
          <CssBaseline />
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <img
              src={imgWinningRegister}
              alt="logo"
              className={classeStyle.imgCashBack}
            />
          </Grid>
          <Grid padding={2}>
            <Typography>✨ {dataWinningRegister.dsPremiacao} ✨</Typography>
            <Typography marginTop={2}>📆 Atenção nas datas:</Typography>
            <Typography marginTop={2}>
              * Novos usuários cadastrados de{' '}
              <b>{dataWinningRegister.dtInicio}</b> a{' '}
              <b>{dataWinningRegister.dtFim}</b> concorrem ao sorteio (usuários
              que já possuem contas antigas não irão concorrer).
            </Typography>
            <Typography marginTop={2}>
              * <b>{dataWinningRegister.dtPremiacao}</b> às{' '}
              <b>{dataWinningRegister.hrPremiacao}</b> é o dia do sorteio.
            </Typography>
            {dataWinningRegister.arrFormaPagamentos.length > 0 && (
              <Typography
                marginTop={2}
                onClick={() => setOpenModalListPaymentFormat(true)}
                className={classeStyle.textFontSizeMin}
              >
                📌 Veja aqui as{' '}
                <b className={classeStyle.textNoBoldUnderlined}>
                  Formas de Pagamento
                </b>{' '}
                aceitas.
              </Typography>
            )}
            <Typography
              marginTop={2}
              onClick={() => setOpenModalListAwards(true)}
              className={classeStyle.textFontSizeMin}
            >
              📌 Veja aqui a lista de{' '}
              <b className={classeStyle.textNoBoldUnderlined}>Prêmios</b> do
              sorteio.
            </Typography>
            {dataWinningRegister.flgAtivo === '2' && (
              <Typography
                marginTop={2}
                onClick={() => setOpenModalListWinners(true)}
                className={classeStyle.textFontSizeMin}
              >
                📌 Veja aqui a lista dos{' '}
                <b className={classeStyle.textNoBoldUnderlined}>Ganhadores</b>{' '}
                do sorteio.
              </Typography>
            )}
            <Typography
              marginTop={2}
              onClick={() => handleToLink(dataWinningRegister.dsUrlSorteio)}
              className={classeStyle.textFontSizeMin}
            >
              ⏰ No horário do sorteio, você pode ver a live{' '}
              <b className={classeStyle.textNoBoldUnderlined}>aqui</b>
            </Typography>
          </Grid>
        </>
      )}
      <ModalListCenter
        isOpen={openModalListPaymentFormat}
        title="FORMAS DE PAGAMENTO"
        dataList={dataWinningRegister.arrFormaPagamentos}
        handleFn={async () => setOpenModalListPaymentFormat(false)}
        onClose={() => setOpenModalListPaymentFormat(false)}
      />
      <ModalListCenter
        isOpen={openModalListAwards}
        title="PRÊMIOS"
        dataList={dataListAwarded}
        handleFn={async () => setOpenModalListAwards(false)}
        onClose={() => setOpenModalListAwards(false)}
      />
      <ModalListCenter
        isOpen={openModalListWinners}
        title="GANHADORES"
        dataList={dataListWinners}
        handleFn={async () => setOpenModalListWinners(false)}
        onClose={() => setOpenModalListWinners(false)}
      />
      <ModalConfirmFooter
        isOpen={openModalNotice}
        title={msgnModalNotice.title}
        message={msgnModalNotice.messagem}
        btnNamePrimary="Ok"
        btnNameSecondary=""
        btnCancel=""
        handleFn={async () => handleCloseModalNotice()}
        onClose={() => handleCloseModalNotice()}
        heightModal="400px"
      />

      <FooterMenuMain children="fidelity" />
    </Container>
  );
};

export default Winningregister;
